import clsx from 'clsx';

import type * as api from '@gitbook/api-client';
import { IconTile } from '@gitbook/spine-react';

import { IntegrationIcon } from './IntegrationIcon';

/**
 * Icon for an integration in a tile.
 */
export function IntegrationTileIcon(props: {
    integration: api.Integration;
    size: number;
    className?: string;
}) {
    const { integration, size, className } = props;
    return (
        <IconTile
            size={size}
            bordered={false}
            className={clsx('shrink-0 bg-white shadow-base', className)}
        >
            <IntegrationIcon integration={integration} className="size-full" />
        </IconTile>
    );
}
